import Vue from 'vue'
import { connectorConfig } from './connector_config'

var errorConnector = null

var connector = {	
	get: (type, params) => {
		if (connectorConfig[type]) {
			return connectorConfig[type].get(params.url, params)
		} else {
			errorConnector = 'No existe el tipo ' + type
			console.log(errorConnector)
		}
	},
	post: (type, params) => {
		if (connectorConfig[type]) {
			return connectorConfig[type].post(params.url, params)
		} else {
			errorConnector = 'No existe el tipo ' + type
			console.log(errorConnector)
		}
	},
	put: (type, params) => {
		if (connectorConfig[type]) {
			return connectorConfig[type].put(params.url, params)
		} else {
			errorConnector = 'No existe el tipo ' + type
			console.log(errorConnector)
		}
	},
	delete: (type, params) => {
		if (connectorConfig[type]) {
			return connectorConfig[type].delete(params.url, params)
		} else {
			errorConnector = 'No existe el tipo ' + type
			console.log(errorConnector)
		}
	}
}

Vue.prototype.$connector = connector

export { connector }